import { useRef } from "react";
import { useOnClickOutside } from "../../hooks/useOnClickOutside";
import { MovieOption, MovieOptionsKeyType } from "../../utils/types";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./OptionsMenu.css";

interface Props {
  visible: boolean;
  options: MovieOption[];
  onOptionClick: (type: MovieOptionsKeyType) => void;
  onClose: () => void;
  onToggle: () => void;
}

export const OptionsMenu = ({
  visible,
  options,
  onOptionClick,
  onClose,
  onToggle,
}: Props) => {

  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, onClose);

  return (
    <div
      ref={ref}
      className="options-menu-container"
      style={{
        position: "absolute",
        right: 8,
        top: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        zIndex: 10,
      }}
    >
      {/* Hitslop of 10 applied via CSS pseudo-element on this toggle button */}
      <div
        className="options-menu-toggle"
        onClick={onToggle}
        style={{
          backgroundColor: "rgba(15, 23, 42, 0.65)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          borderRadius: "50%",
          display: "flex",
          cursor: "pointer",
          padding: "5px",
          color: "white",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        }}
      >
        <MoreVertIcon fontSize="small" />
      </div>
      {visible && (
        <div
          className="options-dropdown"
          style={{
            position: "absolute",
            top: 36,
            right: 0,
            zIndex: 11,
          }}
        >
          {options.map((item) => (
            <div
              key={item.type}
              className="options-item"
              onClick={() => onOptionClick(item.type)}
            >
              <div style={{ flexShrink: 0, display: "flex" }}>{item.icon}</div>
              <span
                className="options-label"
                style={{
                  marginLeft: item.icon ? 10 : 0,
                }}
              >
                {item.title}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
